import React, { useState, useEffect } from 'react';
import { FiSettings, FiCalendar, FiFilm, FiHome, FiCheckSquare, FiDollarSign } from 'react-icons/fi';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import axios from 'axios';
import MovieServices from "../../services/externalServices/TicketServices/moviesServices";
import TheatreServices from "../../services/externalServices/TicketServices/theatreServices";
import showTimeServices from "../../services/externalServices/TicketServices/showTimeServices";
import DynamicServices from '../../services/externalServices/TicketServices/dynamicServices';
import "react-datepicker/dist/react-datepicker.css";
import { IndianRupee } from 'lucide-react';
import moment from 'moment';



// const DynamicPricing = () => {
//     // const [formData, setFormData] = useState({
//     //     theatreId: '',
//     //     movieId: '',
//     //     selectedDate: '',
//     //     seatLayout: [], // Store the seat layout data
//     // });

//     const [formData, setFormData] = useState({
//         theatreId: '',
//         selectedMovie: '',
//         seatLayout: [],
//         selectedDates: [], // Instead of selectedDate
//         selectedShowTimes: {}, // { '2024-04-29': ['10:00 AM', '1:00 PM'] }
//         validityFrom: '',
//         validityUntil: ''
//     });
//     const [theatres, setTheatres] = useState([]); // Populate with your theatre data
//     const [movies, setMovies] = useState([]); // Populate with your movie data
//     const [availableShowTimes, setAvailableShowTimes] = useState([]);
//     const [selectedMovie, setSelectedMovie] = useState('');
//     const [selectedTheatre, setSelectedTheatre] = useState('');
//     const [loading, setLoading] = useState(false);


//     const { firstname, lastname, role = "", accessList = [] } = JSON.parse(localStorage.getItem("admin"));
//     const isTicketAdmin = role === 'ticket-admin';
//     const theatreName = accessList?.[0];

//     useEffect(() => {
//         const fetchData = async () => {
//             try {
//                 const movies = await MovieServices.getMovies(theatreName);
//                 setMovies(movies);

//                 const res = await TheatreServices.getTheatres();
//                 if (Array.isArray(res)) {
//                     let filteredTheatres = res;
//                     if (role === "ticket-admin") {
//                         filteredTheatres = res.filter((theatre) =>
//                             accessList.includes(theatre.name)
//                         );
//                     }
//                     setTheatres(filteredTheatres);
//                     if (filteredTheatres.length > 0) {
//                         setSelectedTheatre(filteredTheatres[0].name);
//                     }
//                 }
//             } catch (err) {
//                 console.error("Error fetching data:", err);
//             }
//         };

//         fetchData();
//     }, []);

//     // Fetch showtimes and seat layout based on selected movie and theatre
//     useEffect(() => {
//         const fetchShowTimes = async () => {
//             setLoading(true);
//             try {
//                 if (selectedMovie && selectedTheatre) {

//                     console.log('selected Movie and thater', selectedMovie, selectedTheatre)
//                     const selectedTheatreDetails = theatres.find(t => t.name === selectedTheatre);

//                     // const params = {
//                     //     theatreName: selectedTheatre,
//                     //     movieId: selectedMovie,
//                     //     theatreId: selectedTheatreDetails._id,
//                     // };

//                     // const response = await DynamicServices.getDynamicShowSchedules({ params });
//                     console.log('selectedTheatreDetails._id', selectedTheatreDetails._id, formData.theatreId,)

//                     const response = await DynamicServices.getDynamicShowSchedules({
//                         theatreName: theatreName,
//                         movieId: selectedMovie,
//                         theatreId: formData.theatreId,
//                     });

//                     // const response = await axios.get(
//                     //     `http://localhost:4123/api/movieShowSchedule/getDynamicShowSchedules`,
//                     //     {
//                     //         params: {
//                     //             theatreName: selectedTheatre,
//                     //             movieId: selectedMovie,
//                     //             theatreId: selectedTheatreDetails._id,
//                     //         },
//                     //     }
//                     // );

//                     console.log('Response Data:', JSON.stringify(response, null, 2));

//                     if (Array.isArray(response) && response.length > 0) {
//                         const theatreDetails = response[0].theatreDetails[0];
//                         const showTimes = theatreDetails.showTimes;
//                         const seatLayout = theatreDetails.seatLayout;
//                         const validityFrom = response[0].validityFrom;
//                         const validityUntil = response[0].validityUntil;


//                         // Set the showtimes and seat layout
//                         // setAvailableShowTimes(showTimes);
//                         // setAvailableShowTimes(shows);
//                         // setAvailableShowTimes(theatreDetails.shows || []);


//                         const formattedShowTimes = (theatreDetails.shows || []).map(
//                             show => `${show.time}`
//                           );
//                           setAvailableShowTimes(formattedShowTimes);

//                         setFormData((prevData) => ({
//                             ...prevData,
//                             seatLayout: seatLayout, // Populate seat layout
//                             validityFrom,
//                             validityUntil,
//                         }));
//                     }
//                 }
//             } catch (err) {
//                 console.error("Error fetching showtimes:", err);
//             } finally {
//                 setLoading(false);
//             }
//         };

//         fetchShowTimes();
//     }, [selectedMovie, selectedTheatre, theatres]);

//     // Handle form field changes
//     const handleChange = (e, index, field) => {
//         const updatedSeatLayout = [...formData.seatLayout];
//         updatedSeatLayout[index][field] = e.target.value;
//         setFormData((prevData) => ({
//             ...prevData,
//             seatLayout: updatedSeatLayout,
//         }));
//     };

//     // Handle submit
//     const handleSubmit = async () => {
//         // Handle form submission logic here
//         // First validate required fields
//         //    if (!formData.selectedDates.length) {
//         //     alert('Please select at least one date.');
//         //     return; // Exit the function if validation fails
//         //   }

//         console.log('Form Submitted:', selectedMovie);
//         console.log('Form Submitted:', JSON.stringify({
//             theatreId: formData.theatreId,
//             showtimeId: selectedMovie,
//             // showtimeId: formData.showtimeId,
//             selectedDates: formData.selectedDates, // Sending the array of dates
//             time: formData.selectedShowTimes,
//             seatLayout: formData.seatLayout,
//         }));

//         // Make sure the selectedDates is an array of valid dates
//         if (formData.selectedDates && formData.selectedDates.length > 0) {
//             //   const response = await fetch('http://localhost:4123/api/dynamic/createDynamicPrice', {
//             //     method: 'POST',
//             //     headers: {
//             //       'Content-Type': 'application/json',
//             //     },
//             //     body: JSON.stringify({
//             //       theatreId: formData.theatreId,
//             //       showtimeId: selectedMovie,
//             //       selectedDates: formData.selectedDates, // Sending the array of dates
//             //       time: formData.selectedShowTimes,
//             //       seatLayout: formData.seatLayout,
//             //     }),
//             //   });

//             const response = await DynamicServices.createDynamicPrice({
//                 theatreId: formData.theatreId,
//                 showtimeId: selectedMovie,
//                 selectedDates: formData.selectedDates, // Sending the array of dates
//                 time: formData.selectedShowTimes,
//                 seatLayout: formData.seatLayout,
//             });

//             console.log('response in the dynamc pricing', response.error);


//             if (response.message == 'Dynamic Pricing Updated') {

//                 console.log('1st if')
//                 const data = await response; // Parse JSON from response
//                 alert('Success: ' + data.message); // Directly access the message from the response
//                 // Clear the form fields
//                 clearFormData(); // This function will reset the formData object
//             } else if(response.error =='Cannot update pricing as the seat layout has already been set from the Master Layout.'){

//                 console.log('2nd if')
//                 const errorData = await response; // If the response is not ok, parse error data
//                 alert('Error: ' + errorData.error || 'Unknown error occurred'); // Show error message from response
//             }else {
//                 console.log('3rd if')
//                 const errorData = await response; // If the response is not ok, parse error data
//                 alert('Error: ' + errorData.error || 'Unknown error occurred'); // Show error message from response
//             }
//             //   const data = await response.json();
//             //   if (response.ok) {
//             //     // Handle success - show an alert
//             //     alert('Success: ' + data.message);
//             //   } else {
//             //     // Handle error - show an alert
//             //     alert('Error: ' + data.error);
//             //   }
//         }

//         else {
//             alert('Please select at least one date.');
//         }
//     };

//     // Function to reset formData
//     const clearFormData = () => {
//         setSelectedMovie('')
//         setAvailableShowTimes([]);
//         setFormData({
//             theatreId: '',
//             selectedDates: [],

//             selectedShowTimes: '',
//             seatLayout: [],
//         });
//     };

//     return (
//         <div className="min-h-screen bg-gradient-to-br from-gray-50 to-blue-50 p-8">
//             <div className="max-w-7xl mx-auto">
//                 {/* Header */}
//                 <div className="mb-12 text-center">
//                     <h1 className="text-4xl font-bold text-gray-900 mb-4 flex items-center justify-center gap-3">
//                         <FiSettings className="text-blue-600" />
//                         Dynamic Pricing
//                     </h1>
//                     <p className="text-lg text-gray-600">
//                         Smart pricing configuration for optimal revenue management
//                     </p>
//                 </div>

//                 {/* Main Card */}
//                 <div className="bg-white rounded-2xl shadow-2xl p-8 mb-8">
//                     {/* Configuration Steps */}
//                     <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 mb-12">
//                         {/* Theatre Selection */}
//                         <div className="space-y-4">
//                             <div className="flex items-center gap-3 mb-6">
//                                 <div className="p-3 bg-blue-100 rounded-lg">
//                                     <FiHome className="text-2xl text-blue-600" />
//                                 </div>
//                                 <h3 className="text-xl font-semibold text-gray-800">Select Theater</h3>
//                             </div>
//                             <select
//                                 value={formData.theatreId}
//                                 onChange={(e) => setFormData({ ...formData, theatreId: e.target.value })}
//                                 className="w-full px-4 py-3 rounded-xl border border-gray-200 focus:border-blue-500 focus:ring-2 focus:ring-blue-200 transition-all"
//                             >
//                                 <option value="">Choose Theatre...</option>
//                                 {theatres.map((theatre) => (
//                                     <option key={theatre._id} value={theatre._id}>
//                                         {theatre.name}
//                                     </option>
//                                 ))}
//                             </select>
//                         </div>

//                         {/* Movie Selection */}
//                         <div className="space-y-4">
//                             <div className="flex items-center gap-3 mb-6">
//                                 <div className="p-3 bg-purple-100 rounded-lg">
//                                     <FiFilm className="text-2xl text-purple-600" />
//                                 </div>
//                                 <h3 className="text-xl font-semibold text-gray-800">Select Movie</h3>
//                             </div>
//                             <select
//                                 value={selectedMovie}
//                                 onChange={(e) => setSelectedMovie(e.target.value)}
//                                 className="w-full px-4 py-3 rounded-xl border border-gray-200 focus:border-blue-500 focus:ring-2 focus:ring-blue-200 transition-all"
//                             >
//                                 <option value="">Choose Movie...</option>
//                                 {movies.map((movie) => (
//                                     <option key={movie._id} value={movie._id}>
//                                         {movie.name}
//                                     </option>
//                                 ))}
//                             </select>
//                         </div>
//                     </div>

//                     {/* Date & Time Section */}
//                     {loading ? (
//                         <div className="flex justify-center py-12">
//                             <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-blue-500"></div>
//                         </div>
//                     ) : availableShowTimes.length === 0 ? (
//                         <div className="text-center py-12 bg-gray-50 rounded-xl">
//                             <div className="text-gray-400 mb-4 text-6xl">🎬</div>
//                             <h3 className="text-xl font-semibold text-gray-800 mb-2">No Screenings Available</h3>
//                             <p className="text-gray-600">Please select a theatre and movie to view schedules</p>
//                         </div>
//                     ) : (
//                         <>
//                             <div className="grid grid-cols-1 xl:grid-cols-[290px_1fr] gap-8 mb-12">
//                                 {/* Calendar Section */}
//                                 <div className="bg-gray-50 p-6 rounded-xl">
//                                     <div className="flex items-center gap-3 mb-6">
//                                         <div className="p-3 bg-green-100 rounded-lg">
//                                             <FiCalendar className="text-2xl text-green-600" />
//                                         </div>
//                                         <h3 className="text-xl font-semibold text-gray-800">Schedule Dates</h3>
//                                     </div>
//                                     <DatePicker
//                                         inline
//                                         selected={null}
//                                         onSelect={(date) => {
//                                             const iso = date.toLocaleDateString('en-CA');
//                                             setFormData(prev => {
//                                                 const newSelectedDates = prev.selectedDates.includes(iso)
//                                                     ? prev.selectedDates.filter(d => d !== iso)
//                                                     : [...prev.selectedDates, iso];
//                                                 const newSelectedShowTimes = { ...prev.selectedShowTimes };
//                                                 if (!newSelectedDates.includes(iso)) {
//                                                     delete newSelectedShowTimes[iso];
//                                                 }
//                                                 return {
//                                                     ...prev,
//                                                     selectedDates: newSelectedDates,
//                                                     selectedShowTimes: newSelectedShowTimes
//                                                 };
//                                             });
//                                         }}
//                                         highlightDates={formData.selectedDates.map(d => new Date(d))}
//                                         minDate={formData.validityFrom ? new Date(formData.validityFrom) : null}
//                                         maxDate={formData.validityUntil ? new Date(formData.validityUntil) : null}
//                                         calendarClassName="w-full"
//                                         dayClassName={(date) =>
//                                             formData.selectedDates.includes(date.toLocaleDateString('en-CA'))
//                                                 ? 'bg-blue-500 text-white rounded-full'
//                                                 : undefined
//                                         }
//                                     />
//                                 </div>

//                                 {/* Showtimes Section */}
//                                 <div className="space-y-6">
//                                     <div className="flex items-center gap-3 mb-6 pt-3.5">
//                                         <div className="p-3 bg-orange-100 rounded-lg">
//                                             <FiCheckSquare className="text-2xl text-orange-600" />
//                                         </div>
//                                         <h3 className="text-xl font-semibold text-gray-800">Select Showtimes</h3>
//                                     </div>
//                                     <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
//                                         {formData.selectedDates.map(date => (
//                                             <div key={date} className="bg-white border border-gray-200 rounded-xl p-4 shadow-sm">
//                                                 <h4 className="font-semibold text-gray-700 mb-3">
//                                                     {new Date(date).toLocaleDateString('en-US', { weekday: 'long', month: 'short', day: 'numeric' })}
//                                                 </h4>
//                                                 <div className="grid grid-cols-2 gap-2">
//                                                     {availableShowTimes.map((time, index) => {
//                                                         const checked = formData.selectedShowTimes[date]?.includes(time) || false;
//                                                         return (
//                                                             <label
//                                                                 key={index}
//                                                                 className={`flex items-center gap-2 p-2 rounded-lg cursor-pointer transition-colors ${checked
//                                                                         ? 'bg-blue-50 border border-blue-200'
//                                                                         : 'hover:bg-gray-50 border border-transparent'
//                                                                     }`}
//                                                             >
//                                                                 <input
//                                                                     type="checkbox"
//                                                                     checked={checked}
//                                                                     onChange={() => {
//                                                                         setFormData(prev => {
//                                                                             const prevTimes = prev.selectedShowTimes[date] || [];
//                                                                             const updatedTimes = checked
//                                                                                 ? prevTimes.filter(t => t !== time)
//                                                                                 : [...prevTimes, time];
//                                                                             return {
//                                                                                 ...prev,
//                                                                                 selectedShowTimes: {
//                                                                                     ...prev.selectedShowTimes,
//                                                                                     [date]: updatedTimes
//                                                                                 }
//                                                                             };
//                                                                         });
//                                                                     }}
//                                                                     className="form-checkbox h-4 w-4 text-blue-600 rounded focus:ring-blue-500"
//                                                                 />
//                                                                 <span className="text-gray-700">{time}</span>
//                                                             </label>
//                                                         );
//                                                     })}
//                                                 </div>
//                                             </div>
//                                         ))}
//                                     </div>
//                                 </div>
//                             </div>

//                             {/* Seat Pricing Section */}
//                             <div className="space-y-6">
//                                 <div className="flex items-center gap-3 mb-6">
//                                     <div className="p-3 bg-pink-100 rounded-lg">
//                                         <IndianRupee className="text-2xl text-pink-600" />
//                                     </div>
//                                     <h3 className="text-xl font-semibold text-gray-800">Seat Pricing Configuration</h3>
//                                 </div>
//                                 <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
//                                     {formData.seatLayout.map((seat, index) => (
//                                         <div key={index} className="bg-gray-50 p-4 rounded-xl border border-gray-200">
//                                             <div className="space-y-3">
//                                                 <div>
//                                                     <label className="block text-sm font-medium text-gray-700 mb-1">Section Name</label>
//                                                     <input
//                                                         type="text"
//                                                         value={seat.sectionName}
//                                                         onChange={(e) => handleChange(e, index, 'sectionName')}
//                                                         className="w-full px-3 py-2 rounded-lg border border-gray-300 focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
//                                                     />
//                                                 </div>
//                                                 <div className="grid grid-cols-2 gap-3">
//                                                     <div>
//                                                         <label className="block text-sm font-medium text-gray-700 mb-1">Sequence</label>
//                                                         <input
//                                                             type="number"
//                                                             value={seat.sequence}
//                                                             onChange={(e) => handleChange(e, index, 'sequence')}
//                                                             className="w-full px-3 py-2 rounded-lg border border-gray-300 focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
//                                                         />
//                                                     </div>
//                                                     <div>
//                                                         <label className="block text-sm font-medium text-gray-700 mb-1">Price ($)</label>
//                                                         <input
//                                                             type="number"
//                                                             value={seat.price}
//                                                             onChange={(e) => handleChange(e, index, 'price')}
//                                                             className="w-full px-3 py-2 rounded-lg border border-gray-300 focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
//                                                         />
//                                                     </div>
//                                                 </div>
//                                             </div>
//                                         </div>
//                                     ))}
//                                 </div>
//                             </div>
//                         </>
//                     )}

//                     {/* Validation & Actions */}
//                     <div className="mt-12 pt-8 border-t border-gray-200">
//                         {formData.selectedDates.some(date => !(formData.selectedShowTimes[date]?.length)) && (
//                             <div className="bg-red-50 border-l-4 border-red-400 p-4 mb-6 rounded-lg">
//                                 <div className="flex items-center gap-3">
//                                     <svg className="w-5 h-5 text-red-400" fill="currentColor" viewBox="0 0 20 20">
//                                         <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z" clipRule="evenodd" />
//                                     </svg>
//                                     <span className="text-red-700">Please select at least one showtime for each selected date</span>
//                                 </div>
//                             </div>
//                         )}

//                         <div className="flex flex-col sm:flex-row justify-end gap-4">
//                             <button
//                                 onClick={clearFormData}
//                                 className="px-6 py-3 rounded-xl bg-gray-100 text-gray-700 hover:bg-gray-200 transition-colors"
//                             >
//                                 Reset Configuration
//                             </button>
//                             <button
//                                 onClick={handleSubmit}
//                                 disabled={formData.selectedDates.some(date => !(formData.selectedShowTimes[date]?.length))}
//                                 className={`px-6 py-3 rounded-xl transition-all ${formData.selectedDates.some(date => !(formData.selectedShowTimes[date]?.length))
//                                         ? 'bg-gray-300 text-gray-500 cursor-not-allowed'
//                                         : 'bg-black text-white shadow-lg hover:shadow-xl'
//                                     }`}
//                             >
//                                 Confirm
//                             </button>
//                         </div>
//                     </div>
//                 </div>
//             </div>
//         </div>
//     );
// };

// export default DynamicPricing;




// const DynamicPricing = () => {
//     const [formData, setFormData] = useState({
//         theatreId: '',
//         selectedMovie: '',
//         seatLayout: [],
//         selectedDates: [],
//         selectedShowTimes: {},
//         validityFrom: '',
//         validityUntil: ''
//     });

//     const [theatres, setTheatres] = useState([]);
//     const [movies, setMovies] = useState([]);
//     const [availableShowTimes, setAvailableShowTimes] = useState([]);
//     const [selectedMovie, setSelectedMovie] = useState('');
//     const [selectedTheatre, setSelectedTheatre] = useState('');
//     const [loading, setLoading] = useState(false);

//     const { role = "", accessList = [] } = JSON.parse(localStorage.getItem("admin") || '{}');
//     const theatreName = accessList?.[0];

//     useEffect(() => {
//         const fetchTheatres = async () => {
//             const res = await TheatreServices.getTheatres();
//             if (Array.isArray(res)) {
//                 let filtered = res;
//                 if (role === "ticket-admin") {
//                     filtered = res.filter(t => accessList.includes(t.name));
//                 }
//                 setTheatres(filtered);
//                 if (filtered.length > 0) {
//                     setSelectedTheatre(filtered[0].name);
//                     setFormData(prev => ({ ...prev, theatreId: filtered[0]._id }));
//                 }
//             }
//         };

//         fetchTheatres();
//     }, []);

//     useEffect(() => {
//         const fetchAndFilterMovies = async () => {
//             if (!formData.theatreId) return;
//             const allMovies = await MovieServices.getMovies(theatreName);
//             const filtered = allMovies.filter(movie =>
//                 movie.availableIn?.some(t => t._id === formData.theatreId)
//             );
//             setMovies(filtered);
//         };

//         fetchAndFilterMovies();
//     }, [formData.theatreId]);

//     useEffect(() => {
//         const fetchShowTimes = async () => {
//             setLoading(true);
//             try {
//                 if (selectedMovie && formData.theatreId) {
//                     const res = await DynamicServices.getDynamicShowSchedules({
//                         theatreName,
//                         movieId: selectedMovie,
//                         theatreId: formData.theatreId,
//                     });

//                     if (Array.isArray(res) && res.length > 0) {
//                         const theatreDetails = res[0].theatreDetails?.[0];
//                         if (theatreDetails) {
//                             const formattedTimes = (theatreDetails.shows || []).map(show => show.time);
//                             setAvailableShowTimes(formattedTimes);

//                             setFormData(prev => ({
//                                 ...prev,
//                                 seatLayout: theatreDetails.seatLayout || [],
//                                 validityFrom: res[0].validityFrom,
//                                 validityUntil: res[0].validityUntil,
//                             }));
//                         }
//                     }
//                 }
//             } catch (err) {
//                 console.error("Error fetching showtimes:", err);
//             } finally {
//                 setLoading(false);
//             }
//         };

//         fetchShowTimes();
//     }, [selectedMovie, formData.theatreId]);

//     const handleChange = (e, index, field) => {
//         const updated = [...formData.seatLayout];
//         updated[index][field] = e.target.value;
//         setFormData(prev => ({ ...prev, seatLayout: updated }));
//     };

//     const clearFormData = () => {
//         setSelectedMovie('');
//         setAvailableShowTimes([]);
//         setFormData({
//             theatreId: '',
//             selectedMovie: '',
//             seatLayout: [],
//             selectedDates: [],
//             selectedShowTimes: {},
//             validityFrom: '',
//             validityUntil: ''
//         });
//     };

//     const handleSubmit = async () => {
//         if (!formData.selectedDates.length) {
//             alert('Please select at least one date.');
//             return;
//         }

//         const response = await DynamicServices.createDynamicPrice({
//             theatreId: formData.theatreId,
//             showtimeId: selectedMovie,
//             selectedDates: formData.selectedDates,
//             time: formData.selectedShowTimes,
//             seatLayout: formData.seatLayout,
//         });

//         //   if (response.message === 'Dynamic Pricing Updated') {
//         //     alert('Success: ' + response.message);


//         if (response.message === 'Dynamic Pricing Updated') {
//             let fullMessage = '✅ Success: ' + response.message;

//             if (Array.isArray(response.warnings) && response.warnings.length > 0) {
//                 fullMessage += '\n\n⚠️ Warnings:\n' + response.warnings.join('\n');
//             }

//             alert(fullMessage);

//             clearFormData();
//         } else {
//             alert('Error: ' + (response.error || 'Unknown error'));
//         }
//     };

//     return (
//         <div className="min-h-screen bg-gradient-to-br from-gray-50 to-blue-50 p-8">
//             <div className="max-w-7xl mx-auto">
//                 <div className="mb-12 text-center">
//                     <h1 className="text-4xl font-bold text-gray-900 mb-4 flex items-center justify-center gap-3">
//                         <FiSettings className="text-blue-600" />
//                         Dynamic Pricing
//                     </h1>
//                     <p className="text-lg text-gray-600">Smart pricing configuration for optimal revenue management</p>
//                 </div>

//                 <div className="bg-white rounded-2xl shadow-2xl p-8 mb-8">
//                     <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 mb-12">
//                         <div className="space-y-4">
//                             <h3 className="text-xl font-semibold text-gray-800 flex items-center gap-2">
//                                 <FiHome /> Select Theatre
//                             </h3>
//                             <select
//                                 value={formData.theatreId}
//                                 onChange={(e) => {
//                                     const theatreId = e.target.value;
//                                     setFormData(prev => ({ ...prev, theatreId }));
//                                     setSelectedMovie('');
//                                 }}
//                                 className="w-full px-4 py-3 rounded-xl border border-gray-200"
//                             >
//                                 <option value="">Choose Theatre...</option>
//                                 {theatres.map(t => (
//                                     <option key={t._id} value={t._id}>{t.name}</option>
//                                 ))}
//                             </select>
//                         </div>

//                         <div className="space-y-4">
//                             <h3 className="text-xl font-semibold text-gray-800 flex items-center gap-2">
//                                 <FiFilm /> Select Movie
//                             </h3>
//                             <select
//                                 value={selectedMovie}
//                                 onChange={(e) => setSelectedMovie(e.target.value)}
//                                 className="w-full px-4 py-3 rounded-xl border border-gray-200"
//                             >
//                                 <option value="">Choose Movie...</option>
//                                 {movies.map(m => (
//                                     <option key={m._id} value={m._id}>{m.name}</option>
//                                 ))}
//                             </select>
//                         </div>
//                     </div>

//                     {loading ? (
//                         <div className="flex justify-center py-12">
//                             <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-blue-500"></div>
//                         </div>
//                     ) : availableShowTimes.length === 0 ? (
//                         <div className="text-center py-12 bg-gray-50 rounded-xl">
//                             <div className="text-gray-400 mb-4 text-6xl">🎬</div>
//                             <h3 className="text-xl font-semibold text-gray-800 mb-2">No Screenings Available</h3>
//                             <p className="text-gray-600">Please select a theatre and movie to view schedules</p>
//                         </div>
//                     ) : (
//                         <>
//                             {/* Date Picker and Showtimes */}
//                             <div className="grid grid-cols-1 xl:grid-cols-[290px_1fr] gap-8 mb-12">
//                                 <div className="bg-gray-50 p-6 rounded-xl">
//                                     <h3 className="text-xl font-semibold text-gray-800 mb-6 flex items-center gap-2">
//                                         <FiCalendar /> Schedule Dates
//                                     </h3>
//                                     <DatePicker
//                                         inline
//                                         selected={null}
//                                         onSelect={(date) => {
//                                             const iso = date.toLocaleDateString('en-CA');
//                                             setFormData(prev => {
//                                                 const isSelected = prev.selectedDates.includes(iso);
//                                                 const updatedDates = isSelected
//                                                     ? prev.selectedDates.filter(d => d !== iso)
//                                                     : [...prev.selectedDates, iso];
//                                                 const updatedTimes = { ...prev.selectedShowTimes };
//                                                 if (!updatedDates.includes(iso)) delete updatedTimes[iso];
//                                                 return {
//                                                     ...prev,
//                                                     selectedDates: updatedDates,
//                                                     selectedShowTimes: updatedTimes
//                                                 };
//                                             });
//                                         }}
//                                         highlightDates={formData.selectedDates.map(d => new Date(d))}
//                                         minDate={formData.validityFrom ? new Date(formData.validityFrom) : null}
//                                         maxDate={formData.validityUntil ? new Date(formData.validityUntil) : null}
//                                     />
//                                 </div>

//                                 {/* Showtimes */}
//                                 <div>
//                                     <h3 className="text-xl font-semibold text-gray-800 mb-6 flex items-center gap-2">
//                                         <FiCheckSquare /> Select Showtimes
//                                     </h3>
//                                     <div className="space-y-4">
//                                         {formData.selectedDates.map(date => (
//                                             <div key={date} className="border p-4 rounded-xl bg-white">
//                                                 <h4 className="text-sm font-semibold mb-3 text-gray-700">
//                                                     {new Date(date).toLocaleDateString('en-US', { weekday: 'long', month: 'short', day: 'numeric' })}
//                                                 </h4>
//                                                 <div className="grid grid-cols-2 gap-2">
//                                                     {availableShowTimes.map(time => {
//                                                         const checked = formData.selectedShowTimes[date]?.includes(time) || false;
//                                                         return (
//                                                             <label key={time} className={`flex items-center gap-2 p-2 rounded-lg ${checked ? 'bg-blue-50 border border-blue-200' : 'hover:bg-gray-50'}`}>
//                                                                 <input
//                                                                     type="checkbox"
//                                                                     checked={checked}
//                                                                     onChange={() => {
//                                                                         setFormData(prev => {
//                                                                             const times = prev.selectedShowTimes[date] || [];
//                                                                             const updatedTimes = checked
//                                                                                 ? times.filter(t => t !== time)
//                                                                                 : [...times, time];
//                                                                             return {
//                                                                                 ...prev,
//                                                                                 selectedShowTimes: {
//                                                                                     ...prev.selectedShowTimes,
//                                                                                     [date]: updatedTimes
//                                                                                 }
//                                                                             };
//                                                                         });
//                                                                     }}
//                                                                 />
//                                                                 {time}
//                                                             </label>
//                                                         );
//                                                     })}
//                                                 </div>
//                                             </div>
//                                         ))}
//                                     </div>
//                                 </div>
//                             </div>

//                             {/* Seat Pricing */}
//                             <div className="space-y-6">
//                                 <div className="flex items-center gap-3 mb-6">
//                                     <div className="p-3 bg-pink-100 rounded-lg">
//                                         <IndianRupee className="text-2xl text-pink-600" />
//                                     </div>
//                                     <h3 className="text-xl font-semibold text-gray-800">Seat Pricing Configuration</h3>
//                                 </div>
//                                 <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
//                                     {formData.seatLayout.map((seat, index) => (
//                                         <div key={index} className="bg-gray-50 p-4 rounded-xl border border-gray-200">
//                                             <div className="space-y-3">
//                                                 <div>
//                                                     <label className="block text-sm font-medium text-gray-700 mb-1">Section Name</label>
//                                                     <input
//                                                         type="text"
//                                                         value={seat.sectionName}
//                                                         onChange={(e) => handleChange(e, index, 'sectionName')}
//                                                         className="w-full px-3 py-2 rounded-lg border"
//                                                     />
//                                                 </div>
//                                                 <div className="grid grid-cols-2 gap-3">
//                                                     <div>
//                                                         <label className="block text-sm font-medium text-gray-700 mb-1">Sequence</label>
//                                                         <input
//                                                             type="number"
//                                                             value={seat.sequence}
//                                                             onChange={(e) => handleChange(e, index, 'sequence')}
//                                                             className="w-full px-3 py-2 rounded-lg border"
//                                                         />
//                                                     </div>
//                                                     <div>
//                                                         <label className="block text-sm font-medium text-gray-700 mb-1">Price</label>
//                                                         <input
//                                                             type="number"
//                                                             value={seat.price}
//                                                             onChange={(e) => handleChange(e, index, 'price')}
//                                                             className="w-full px-3 py-2 rounded-lg border"
//                                                         />
//                                                     </div>
//                                                 </div>
//                                             </div>
//                                         </div>
//                                     ))}
//                                 </div>
//                             </div>
//                         </>
//                     )}

//                     {/* Submit */}
//                     <div className="mt-12 pt-8 border-t border-gray-200">
//                         <div className="flex justify-end gap-4">
//                             <button
//                                 onClick={clearFormData}
//                                 className="px-6 py-3 rounded-xl bg-gray-100 text-gray-700 hover:bg-gray-200"
//                             >
//                                 Reset
//                             </button>
//                             <button
//                                 onClick={handleSubmit}
//                                 disabled={formData.selectedDates.some(d => !(formData.selectedShowTimes[d]?.length))}
//                                 className={`px-6 py-3 rounded-xl ${formData.selectedDates.some(d => !(formData.selectedShowTimes[d]?.length)) ? 'bg-gray-300 text-gray-500' : 'bg-black text-white hover:shadow-xl'}`}
//                             >
//                                 Confirm
//                             </button>
//                         </div>
//                     </div>
//                 </div>
//             </div>
//         </div>
//     );
// };


// export default DynamicPricing;



// Working with theater specific 


const DynamicPricing = () => {
    const [formData, setFormData] = useState({
        theatreId: '',
        selectedMovie: '',
        seatLayout: [],
        selectedDates: [],
        selectedShowTimes: {},
        validityFrom: '',
        validityUntil: '',
        pricingType: 'both' // 'convenience', 'pricing', or 'both'
    });

    const [theatres, setTheatres] = useState([]);
    const [movies, setMovies] = useState([]);
    const [availableShowTimes, setAvailableShowTimes] = useState([]);
    const [selectedMovie, setSelectedMovie] = useState('');
    const [selectedTheatre, setSelectedTheatre] = useState('');
    const [loading, setLoading] = useState(false);

    const { role = "", accessList = [] } = JSON.parse(localStorage.getItem("admin") || '{}');
    const theatreName = accessList?.[0];

    useEffect(() => {
        const fetchTheatres = async () => {
            const res = await TheatreServices.getTheatres();
            if (Array.isArray(res)) {
                let filtered = res;
                if (role === "ticket-admin") {
                    filtered = res.filter(t => accessList.includes(t.name));
                }
                setTheatres(filtered);
                if (filtered.length > 0) {
                    setSelectedTheatre(filtered[0].name);
                    setFormData(prev => ({ ...prev, theatreId: filtered[0]._id }));
                }
            }
        };

        fetchTheatres();
    }, []);

    useEffect(() => {
        const fetchAndFilterMovies = async () => {
            if (!formData.theatreId) return;
            const allMovies = await MovieServices.getMovies(theatreName);
            const filtered = allMovies.filter(movie =>
                movie.availableIn?.some(t => t._id === formData.theatreId)
            );
            setMovies(filtered);
        };

        fetchAndFilterMovies();
    }, [formData.theatreId]);










    const handleShowtimeToggle = async (date, time, checked) => {
        setFormData(prev => {
            const times = prev.selectedShowTimes[date] || [];
            const updatedTimes = checked
                ? times.filter(t => t !== time)
                : [...times, time];

            return {
                ...prev,
                selectedShowTimes: {
                    ...prev.selectedShowTimes,
                    [date]: updatedTimes
                }
            };
        });

        if (!checked) {
            try {
                setLoading(true);

                const res = await DynamicServices.getLatestSeatPricing({
                    theatreId: formData.theatreId,
                    showtimeId: selectedMovie,
                    date,
                    time
                });

                console.log('res:============', res.seatLayout);



                if (res.seatLayout && Array.isArray(res.seatLayout)) {
                    console.log('Seat layout from API:============', res.seatLayout);

                    const mappedLayout = res.seatLayout.map(section => ({
                        sectionName: section.sectionName || section.Name || '',
                        price: section.price ?? section.Price ?? 0,
                        sequence: section.sequence ?? section.Sequence ?? 0,
                        convenienceFee: section.ConvenienceFee ?? 0,
                        rows: section.rows ?? 0,
                        columns: section.columns ?? 0
                    }));

                    console.log('Mapped layout:===========', mappedLayout);

                    setFormData(prev => ({
                        ...prev,
                        seatLayout: mappedLayout
                    }));
                }












            } catch (error) {
                console.error('Error fetching seat layout:', error);
            } finally {
                setLoading(false);
            }
        }
    };






    useEffect(() => {
        const fetchShowTimes = async () => {
            setLoading(true);
            try {
                if (selectedMovie && formData.theatreId) {
                    const res = await DynamicServices.getDynamicShowSchedules({
                        theatreName,
                        movieId: selectedMovie,
                        theatreId: formData.theatreId,
                    });

                    if (Array.isArray(res) && res.length > 0) {
                        const theatreDetails = res[0].theatreDetails?.[0];
                        if (theatreDetails) {
                            const formattedTimes = (theatreDetails.shows || []).map(show => show.time);
                            setAvailableShowTimes(formattedTimes);

                            // Initialize convenienceFee for each seat section if not present
                            const seatLayoutWithConvenience = theatreDetails.seatLayout?.map(section => ({
                                ...section,
                                convenienceFee: section.convenienceFee || 0
                            })) || [];

                            setFormData(prev => ({
                                ...prev,
                                seatLayout: seatLayoutWithConvenience,
                                validityFrom: res[0].validityFrom,
                                validityUntil: res[0].validityUntil
                            }));
                        }
                    }
                }
            } catch (err) {
                console.error("Error fetching showtimes:", err);
            } finally {
                setLoading(false);
            }
        };

        fetchShowTimes();
    }, [selectedMovie, formData.theatreId]);













    const handleChange = (e, index, field) => {
        const updated = [...formData.seatLayout];
        updated[index][field] = e.target.value;
        setFormData(prev => ({ ...prev, seatLayout: updated }));
    };

    const clearFormData = () => {
        setSelectedMovie('');
        setAvailableShowTimes([]);
        setFormData({
            theatreId: '',
            selectedMovie: '',
            seatLayout: [],
            selectedDates: [],
            selectedShowTimes: {},
            validityFrom: '',
            validityUntil: '',
            pricingType: 'both'
        });
    };

    const handlePricingTypeChange = (type) => {
        setFormData(prev => ({ ...prev, pricingType: type }));
    };

    const handleSubmit = async () => {
        if (!formData.selectedDates.length) {
            alert('Please select at least one date.');
            return;
        }

        console.log('pricing Type', formData.pricingType)

        const response = await DynamicServices.createDynamicPrice({
            theatreId: formData.theatreId,
            showtimeId: selectedMovie,
            selectedDates: formData.selectedDates,
            time: formData.selectedShowTimes,
            seatLayout: formData.seatLayout,
            pricingType: formData.pricingType
        });

        if (response.message === 'Dynamic Pricing Updated') {
            let fullMessage = '✅ Success: ' + response.message;

            if (Array.isArray(response.warnings) && response.warnings.length > 0) {
                fullMessage += '\n\n⚠️ Warnings:\n' + response.warnings.join('\n');
            }

            alert(fullMessage);
            clearFormData();
        } else {
            alert('Error: ' + (response.error || 'Unknown error'));
        }
    };

    return (
        <div className="min-h-screen bg-gradient-to-br from-gray-50 to-blue-50 p-8">
            <div className="max-w-7xl mx-auto">
                <div className="mb-12 text-center">
                    <h1 className="text-4xl font-bold text-gray-900 mb-4 flex items-center justify-center gap-3">
                        <FiSettings className="text-blue-600" />
                        Dynamic Pricing
                    </h1>
                    <p className="text-lg text-gray-600">Smart pricing configuration for optimal revenue management</p>
                </div>

                <div className="bg-white rounded-2xl shadow-2xl p-8 mb-8">
                    <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 mb-12">
                        <div className="space-y-4">
                            <h3 className="text-xl font-semibold text-gray-800 flex items-center gap-2">
                                <FiHome /> Select Theatre
                            </h3>
                            <select
                                value={formData.theatreId}
                                onChange={(e) => {
                                    const theatreId = e.target.value;
                                    setFormData(prev => ({ ...prev, theatreId }));
                                    setSelectedMovie('');
                                }}
                                className="w-full px-4 py-3 rounded-xl border border-gray-200"
                            >
                                <option value="">Choose Theatre...</option>
                                {theatres.map(t => (
                                    <option key={t._id} value={t._id}>{t.name}</option>
                                ))}
                            </select>
                        </div>

                        <div className="space-y-4">
                            <h3 className="text-xl font-semibold text-gray-800 flex items-center gap-2">
                                <FiFilm /> Select Movie
                            </h3>
                            <select
                                value={selectedMovie}
                                onChange={(e) => setSelectedMovie(e.target.value)}
                                className="w-full px-4 py-3 rounded-xl border border-gray-200"
                            >
                                <option value="">Choose Movie...</option>
                                {movies.map(m => (
                                    <option key={m._id} value={m._id}>{m.name}</option>
                                ))}
                            </select>
                        </div>
                    </div>

                    {loading ? (
                        <div className="flex justify-center py-12">
                            <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-blue-500"></div>
                        </div>
                    ) : availableShowTimes.length === 0 ? (
                        <div className="text-center py-12 bg-gray-50 rounded-xl">
                            <div className="text-gray-400 mb-4 text-6xl">🎬</div>
                            <h3 className="text-xl font-semibold text-gray-800 mb-2">No Screenings Available</h3>
                            <p className="text-gray-600">Please select a theatre and movie to view schedules</p>
                        </div>
                    ) : (
                        <>
                            {/* Date Picker and Showtimes */}
                            <div className="grid grid-cols-1 xl:grid-cols-[290px_1fr] gap-8 mb-12">
                                <div className="bg-gray-50 p-6 rounded-xl">
                                    <h3 className="text-xl font-semibold text-gray-800 mb-6 flex items-center gap-2">
                                        <FiCalendar /> Schedule Dates
                                    </h3>
                                    <DatePicker
                                        inline
                                        selected={null}
                                        onSelect={(date) => {
                                            const iso = date.toLocaleDateString('en-CA');
                                            setFormData(prev => {
                                                const isSelected = prev.selectedDates.includes(iso);
                                                const updatedDates = isSelected
                                                    ? prev.selectedDates.filter(d => d !== iso)
                                                    : [...prev.selectedDates, iso];
                                                const updatedTimes = { ...prev.selectedShowTimes };
                                                if (!updatedDates.includes(iso)) delete updatedTimes[iso];
                                                return {
                                                    ...prev,
                                                    selectedDates: updatedDates,
                                                    selectedShowTimes: updatedTimes
                                                };
                                            });
                                        }}
                                        highlightDates={formData.selectedDates.map(d => new Date(d))}
                                        minDate={formData.validityFrom ? new Date(formData.validityFrom) : null}
                                        maxDate={formData.validityUntil ? new Date(formData.validityUntil) : null}
                                    />
                                </div>

                                {/* Showtimes */}
                                <div>
                                    <h3 className="text-xl font-semibold text-gray-800 mb-6 flex items-center gap-2">
                                        <FiCheckSquare /> Select Showtimes
                                    </h3>
                                    <div className="space-y-4">
                                        {formData.selectedDates.map(date => (
                                            <div key={date} className="border p-4 rounded-xl bg-white">
                                                <h4 className="text-sm font-semibold mb-3 text-gray-700">
                                                    {new Date(date).toLocaleDateString('en-US', { weekday: 'long', month: 'short', day: 'numeric' })}
                                                </h4>
                                                <div className="grid grid-cols-2 gap-2">
                                                    {availableShowTimes.map(time => {
                                                        const checked = formData.selectedShowTimes[date]?.includes(time) || false;
                                                        return (
                                                            <label key={time} className={`flex items-center gap-2 p-2 rounded-lg ${checked ? 'bg-blue-50 border border-blue-200' : 'hover:bg-gray-50'}`}>
                                                                {/* <input
                                                                    type="checkbox"
                                                                    checked={checked}
                                                                    onChange={() => {
                                                                        setFormData(prev => {
                                                                            const times = prev.selectedShowTimes[date] || [];
                                                                            const updatedTimes = checked
                                                                                ? times.filter(t => t !== time)
                                                                                : [...times, time];
                                                                            return {
                                                                                ...prev,
                                                                                selectedShowTimes: {
                                                                                    ...prev.selectedShowTimes,
                                                                                    [date]: updatedTimes
                                                                                }
                                                                            };
                                                                        });
                                                                    }}
                                                                /> */}







                                                                {/* <input
                                                                    type="checkbox"
                                                                    checked={checked}
                                                                    onChange={async () => {
                                                                        setFormData(prev => {
                                                                            const times = prev.selectedShowTimes[date] || [];
                                                                            const updatedTimes = checked
                                                                                ? times.filter(t => t !== time)
                                                                                : [...times, time];

                                                                            return {
                                                                                ...prev,
                                                                                selectedShowTimes: {
                                                                                    ...prev.selectedShowTimes,
                                                                                    [date]: updatedTimes
                                                                                }
                                                                            };
                                                                        });

                                                                        // Fetch updated pricing only on new selection (not removal)
                                                                        if (!checked) {
                                                                            try {

                                                                                const res = await DynamicServices.getLatestSeatPricing({
                                                                                    theatreId: formData.theatreId,
                                                                                    showtimeId: selectedMovie,
                                                                                    date,
                                                                                    time
                                                                                });



                                                                                if (res.data && Array.isArray(res.data.layout)) {
                                                                                    setFormData(prev => ({
                                                                                        ...prev,
                                                                                        seatLayout: res.data.layout
                                                                                    }));
                                                                                } else {
                                                                                    console.warn("No layout returned from pricing API");
                                                                                }
                                                                            } catch (error) {
                                                                                console.error("Error fetching latest pricing layout:", error);
                                                                            }
                                                                        }
                                                                    }}
                                                                /> */}


                                                                <input
                                                                    type="checkbox"
                                                                    checked={checked}
                                                                    onChange={() => handleShowtimeToggle(date, time, checked)}
                                                                />


                                                                {time}
                                                            </label>
                                                        );
                                                    })}
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            </div>

                            {/* Pricing Type Selection */}
                            <div className="flex items-center gap-4 mb-6">
                                <span className="text-sm font-medium text-gray-700">Pricing Type:</span>
                                <div className="flex items-center gap-2">
                                    <label className="flex items-center gap-1">
                                        <input
                                            type="radio"
                                            name="pricingType"
                                            checked={formData.pricingType === 'convenience'}
                                            onChange={() => handlePricingTypeChange('convenience')}
                                            className="h-4 w-4 text-blue-600"
                                        />
                                        <span>Convenience Fee</span>
                                    </label>
                                    <label className="flex items-center gap-1">
                                        <input
                                            type="radio"
                                            name="pricingType"
                                            checked={formData.pricingType === 'pricing'}
                                            onChange={() => handlePricingTypeChange('pricing')}
                                            className="h-4 w-4 text-blue-600"
                                        />
                                        <span>Pricing</span>
                                    </label>
                                    <label className="flex items-center gap-1">
                                        <input
                                            type="radio"
                                            name="pricingType"
                                            checked={formData.pricingType === 'both'}
                                            onChange={() => handlePricingTypeChange('both')}
                                            className="h-4 w-4 text-blue-600"
                                        />
                                        <span>Both</span>
                                    </label>
                                </div>
                            </div>

                            {/* Seat Configuration */}
                            <div className="space-y-6">
                                <div className="flex items-center gap-3 mb-6">
                                    <div className="p-3 bg-pink-100 rounded-lg">
                                        <IndianRupee className="text-2xl text-pink-600" />
                                    </div>
                                    <h3 className="text-xl font-semibold text-gray-800">
                                        {formData.pricingType === 'convenience' ? 'Convenience Fee Configuration' :
                                            formData.pricingType === 'pricing' ? 'Seat Pricing Configuration' :
                                                'Seat Pricing & Convenience Fee Configuration'}
                                    </h3>
                                </div>
                                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
                                    {formData.seatLayout.map((seat, index) => (
                                        <div key={index} className="bg-gray-50 p-4 rounded-xl border border-gray-200">
                                            <div className="space-y-3">
                                                <div>
                                                    <label className="block text-sm font-medium text-gray-700 mb-1">Section Name</label>
                                                    <input
                                                        type="text"
                                                        value={seat.sectionName}
                                                        disabled // ✅ disables editing
                                                        onChange={(e) => handleChange(e, index, 'sectionName')}
                                                        className="w-full px-3 py-2 rounded-lg border"
                                                    />
                                                </div>
                                                <div className="grid grid-cols-2 gap-3">
                                                    <div>
                                                        <label className="block text-sm font-medium text-gray-700 mb-1">Sequence</label>
                                                        <input
                                                            type="number"
                                                            value={seat.sequence}
                                                            disabled // ✅ disables editing
                                                            onChange={(e) => handleChange(e, index, 'sequence')}
                                                            className="w-full px-3 py-2 rounded-lg border"
                                                        />
                                                    </div>
                                                    {(formData.pricingType === 'pricing' || formData.pricingType === 'both') && (
                                                        <div>
                                                            <label className="block text-sm font-medium text-gray-700 mb-1">Price</label>
                                                            <input
                                                                type="number"
                                                                value={seat.price}
                                                                onChange={(e) => handleChange(e, index, 'price')}
                                                                className="w-full px-3 py-2 rounded-lg border"
                                                            />
                                                        </div>
                                                    )}
                                                    {(formData.pricingType === 'convenience' || formData.pricingType === 'both') && (
                                                        <div>
                                                            <label className="block text-sm font-medium text-gray-700 mb-1">Convenience Fee</label>
                                                            <input
                                                                type="number"
                                                                value={seat.convenienceFee || 0}
                                                                onChange={(e) => handleChange(e, index, 'convenienceFee')}
                                                                className="w-full px-3 py-2 rounded-lg border"
                                                            />
                                                        </div>
                                                    )}
                                                </div>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </>
                    )}

                    {/* Submit */}
                    {/* <div className="mt-12 pt-8 border-t border-gray-200">
                        <div className="flex justify-end gap-4">
                            <button
                                onClick={clearFormData}
                                className="px-6 py-3 rounded-xl bg-gray-100 text-gray-700 hover:bg-gray-200"
                            >
                                Reset
                            </button>
                            <button
                                onClick={handleSubmit}
                                disabled={formData.selectedDates.some(d => !(formData.selectedShowTimes[d]?.length))}
                                className={`px-6 py-3 rounded-xl ${formData.selectedDates.some(d => !(formData.selectedShowTimes[d]?.length)) ? 'bg-gray-300 text-gray-500' : 'bg-black text-white hover:shadow-xl'}`}
                            >
                                Confirm
                            </button>
                        </div>
                    </div> */}











                    {/* Validation & Actions */}
                    <div className="mt-12 pt-8 border-t border-gray-200">
                        {formData.selectedDates.some(date => !(formData.selectedShowTimes[date]?.length)) && (
                            <div className="bg-red-50 border-l-4 border-red-400 p-4 mb-6 rounded-lg">
                                <div className="flex items-center gap-3">
                                    <svg className="w-5 h-5 text-red-400" fill="currentColor" viewBox="0 0 20 20">
                                        <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z" clipRule="evenodd" />
                                    </svg>
                                    <span className="text-red-700">Please select at least one showtime for each selected date</span>
                                </div>
                            </div>
                        )}

                        <div className="flex flex-col sm:flex-row justify-end gap-4">
                            <button
                                onClick={clearFormData}
                                className="px-6 py-3 rounded-xl bg-gray-100 text-gray-700 hover:bg-gray-200 transition-colors"
                            >
                                Reset Configuration
                            </button>
                            <button
                                onClick={handleSubmit}
                                disabled={formData.selectedDates.some(date => !(formData.selectedShowTimes[date]?.length))}
                                className={`px-6 py-3 rounded-xl transition-all ${formData.selectedDates.some(date => !(formData.selectedShowTimes[date]?.length))
                                    ? 'bg-gray-300 text-gray-500 cursor-not-allowed'
                                    : 'bg-black text-white shadow-lg hover:shadow-xl'
                                    }`}
                            >
                                Confirm
                            </button>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    );
};

export default DynamicPricing;


// DynamicPricingWithBulkEdit.js





